import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SbvpAuthService } from '../../auth/services/sbvp-auth.service';

//Metadata
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;
  roles?: string[];
  children?: ChildrenItems[];
}

export interface ChildrenItems {
  path: string;
  title: string;
  type?: string;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: 'app.sidebar.component.html',
  styleUrls: ['./app.sidebar.component.scss'],

  standalone: false,})
export class AppSidebarComponent implements OnInit {
  private ps: any;

  constructor(private sbvpAuthService: SbvpAuthService) {}

  public menuItems$?: Observable<RouteInfo[]>;
  ngOnInit() {
    const allRoutes: RouteInfo[] = environment.config.main_menu;
    this.menuItems$ = this.sbvpAuthService.sbvpRole$.pipe(
      map(role =>
        allRoutes.filter(
          item => !item.roles || (role !== null && item.roles.includes(role as string)),
        ),
      ),
    );
  }
  updatePS(): void {
    if (this.ps && window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      this.ps.update();
    }
  }
  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf('MAC') >= 0 ||
      navigator.platform.toUpperCase().indexOf('IPAD') >= 0
    ) {
      bool = true;
    }
    return bool;
  }
}
